<template>
  <div class="consult-list">
    <mobile-header
      :nav-title="navTitle"
      opt-btn="true"
      :opt-txt="optTxt"
      :customOpt="headLeftOpt"
      customColor="#333"
      customBackgroundColor="#fff"
      :header-opt="headerOpt"
    >
    </mobile-header>
    <search-bar
      placeholder="输入用户名/真实姓名搜索订单"
      :fixed="true"
      :isShowButton="true"
      v-model="searchVal"
      @enter="search"
      @cancel="goBack"
      ref="search-bar"
    />
    <LoadMore
      v-if="searchKey"
      :parmas="searchKey"
      class="tab-content"
      @render="renderList"
      :pageCount="10"
      theme="#118bd0"
      ref="tab-content"
    >
      <ConsultationOrderItem
        slot-scope="scope"
        :order="scope.item"
        role="teacher"
        @refresh="refreshList"
      />
      <template slot="none">
        <div class="search-none">
          没有搜索到相关订单
        </div>
      </template>
    </LoadMore>
  </div>
</template>

<script>
import MobileHeader from '../components/MobileHeader'
import ConsultationOrderItem from '../components/consultation/consultationOrderItem'

// import Tabbar from '../components/Tabbar.vue'
import searchBar from '../components/searchBar.vue'
import LoadMore from '../components/LoadMore.vue'
import bridgeMixin from '../mixins/bridge'

export default {
  mixins: [bridgeMixin],
  data() {
    return {
      navTitle: '咨询订单',
      selectedTab: 0,
      searchVal: '',
      searchKey: '',
      // tab切换
      optTxt: '<span>客服</span>',
      headLeftOpt: [
        {
          icon: 'back',
          method: () => {
            window.history.back()
          }
        }
      ]
    }
  },

  components: { MobileHeader, LoadMore, ConsultationOrderItem, searchBar },

  created() {
    var _self = this
    if (window.location.href.indexOf('consult-search') > -1) {
      document.querySelector('html').style.backgroundColor = '#f8f8f8'
      document.querySelector('title').innerText = _self.navTitle
      document.body.style.minHeight = window.screen.height + 'px'
    }
  },

  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const input = this.$refs['search-bar'].$el.querySelector('input')
        console.log(input.focus)
        input.focus()
      }, 1000)
    })
  },

  methods: {
    search() {
      console.log('search')
      this.searchKey = this.searchVal
    },
    refreshList() {
      const content = this.$refs[`tab-content`]
      content && content.refresh()
    },
    renderList(page, callback) {
      const url = `${this.mobileSite}yuyue/yuyuelist?&page=${page}&search=${
        this.searchKey
      }`

      this.$http(url)
        .then(res => {
          if (res.data.code == 0) {
            var resData = res.data.data
            if (resData.role !== 'teacher') {
              const { staticSite } = this
              window.location.href = staticSite + '#/consult-list-user'
            } else {
              // this.role = resData.role
              callback({
                data: resData.list
              })
            }
          } else {
            monitor.stat({
              level: 'error',
              error: 'api',
              url,
              msg: res.data.msg
            })
          }
        })
        .catch(error => {
          monitor.stat({
            level: 'error',
            error: 'api',
            url,
            msg: error
          })
        })
    },
    headerOpt() {
      window.location.href = `${this.staticSite}#/customer-service?source=${
        this.$route.name
      }`
    },
    goToTeacherList() {
      // window.location.href = this.mobileSiteMap[this.env] + 'zx/zixun-teacher';
      this.$router.push({
        path: 'consult-expert-list'
      })
    },
    linkToSearch() {
      this.openWebView({
        url: this.staticSite + '#/consult-search'
      })
    },
    goBack() {
      window.history.back()
    }
  },

  watch: {
    selectedTab(val) {
      if (val === 1) {
        this.isShowBullet && (this.isShowBullet = false)
      }
    }
  },

  computed: {
    staticSite() {
      return location.protocol + '//' + location.host + location.pathname
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/sass/config';
@import '../assets/sass/function';
@import '../assets/sass/mixin';
.consult-list {
  width: 100%;
  margin: 0 auto;
}
.search-none {
  width: 100%;
  line-height: pxToRem(88);
  font-size: pxToRem(26);
  color: #999;
  text-align: center;
  padding: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// ConsultSearch.vue?203dacde